import { render, staticRenderFns } from "./image-input.vue?vue&type=template&id=06268912&"
import script from "./image-input.vue?vue&type=script&lang=js&"
export * from "./image-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports